// ToDo: Delete this when we don't need to support the old nav
export class AANTopNav {
	init(): void {
		const mainNavButtons: HTMLButtonElement[] = Array.from(document.querySelectorAll("#main-nav button"));

		const toggleMobileMenu = (button: HTMLButtonElement) => {
			if (button.parentElement?.classList.contains("submenu-open")) {
				button.parentElement.classList.remove("submenu-open");
			} else {
				button.parentElement?.classList.add("submenu-open");
			}
		};

		mainNavButtons.forEach(button => {
			button.addEventListener("click", () => {
				toggleMobileMenu(button);
			});
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const topNav = new AANTopNav();

	topNav.init();
});
